import React from "react";
export default function WhatsAppButton() {
  return (
    <div className="whatsapp-button">
      <a href="https://wa.me/353874836445" target="_blank">
        <ion-icon name="logo-whatsapp"></ion-icon>
      </a>
    </div>
  );
}
